import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { Button, CursorPointer, Flex, GridItem, ModalScrollContainer } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IFuelTank } from 'types/api/fuelManagementApi.interface'

export const SelectTankModal = ({ closeModal, tankList, selectTank, selectedTank }: { closeModal: any, tankList: IFuelTank[], selectTank: any, selectedTank: number }) => {
    useModalClose(closeModal)
    const [local, setLocal] = useState(selectedTank)

    const handleSave = () => {
        selectTank(local)
        closeModal()
    }

    return <Modal black>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold' >Select Tank</TitleText>
            <CursorPointer onClick={closeModal} >
                <CloseIcon />
            </CursorPointer>
        </Flex>
        <ModalScrollContainer>
            <Flex column gap='1rem'  >
                <GridItem valid={!local} onClick={() => setLocal(null)} >
                    All Tanks
                </GridItem>
                {tankList?.map(t => <GridItem valid={t.id == local} onClick={() => setLocal(t.id)} key={t.id}>
                    {t.name}
                </GridItem>)}
            </Flex>
        </ModalScrollContainer>

        <Flex width='100%' justcenter >
            <Button mt='16' orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ISelectTankModal {
    id?: number
    type: string
}